import { createContext } from "react";

const BecomeStudentContext = createContext();

export default BecomeStudentContext;
